
import {
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";

import { auth } from "./firebase";

const provider = new GoogleAuthProvider();

provider.setCustomParameters({
  prompt: "select_account",
});

export async function signInWithGoogle() {
  const result = await signInWithPopup(auth, provider);

  // Refresh the user's profile from Firebase.
  await result.user.reload();

  return {
    user: auth.currentUser,
    isNewUser: result._tokenResponse?.isNewUser === true,
  };
}
